// extracted by mini-css-extract-plugin
module.exports = {"block":"Block-module__block___1aHs-","icon":"Block-module__icon___38CCd","active":"Block-module__active___pvHXT"};